export const PROFILE_CANCELLATION_REASONS = [
  "I'm taking a break",
  'I have an injury/illness',
  "I'm using a different app or site",
  "It's not value for money",
  "It's not what I expected",
  "I'm bored with Voome",
  'Another reason',
];

export const PROFILE_NUTRITION = [
  {
    key: 'proteinList',
    label: 'Proteins',
    question: 'What proteins do you prefer to eat?',
    type: 'checkbox',
  },
  {
    key: 'mealTypeList',
    label: 'Meal Types',
    question: 'What sort of food do you enjoy? You may pick a few.',
    type: 'checkbox',
  },
  {
    key: 'mealList',
    label: 'Meal List',
    question: 'Which meals are you thinking of cooking with Voome recipes?',
    type: 'checkbox',
  },
  {
    key: 'allergyList',
    label: 'Food Allergies',
    question: 'Specific dietary needs?',
    type: 'checkbox',
  },
];

export const PROFILE_WORKOUT = [
  {
    key: 'fitnessLevelList',
    label: 'Fitness Level',
    question: 'How would you rate your fitness?',
    type: 'radio',
  },
  {
    key: 'fitnessLocationList',
    label: 'Workout Location',
    question: 'Where do you like to workout? You can pick more than one.',
    type: 'checkbox',
  },
  {
    key: 'fitnessTypeList',
    label: 'Focus',
    question: 'What would you like to focus or improve on?',
    type: 'checkbox',
  },
];



// WEBPACK FOOTER //
// ./src/constants/Member.js